import { useGetGaiaObjectQuery } from "pages/gaia-object-overview/endpoints";
import {
  useGetScanResultQuery,
  useGetScanjobQuery,
} from "pages/draft-overview/endpoints";
import { useGetContactsListQuery } from "components/contacts-table/endpoints";
import { GaiaConstants } from "utils";

/**
 * Custom hook for data loading queries only
 * Handles all data fetching operations for the form
 */
export const useLoadData = (
  teamName: string,
  adapter: any,
  shortId?: string
) => {
  const shouldLoadGaiaObject = adapter.shouldLoadGaiaObject();
  const shouldLoadScanResult = adapter.shouldLoadScanResult();
  const shouldLoadScanJob = adapter.shouldLoadScanJob();

  const {
    data: gaiaObjectData,
    error: gaiaObjectError,
    isLoading: gaiaObjectLoading,
    isError: gaiaObjectIsError,
  } = useGetGaiaObjectQuery(
    { gaiaObjectId: shortId! },
    { refetchOnMountOrArgChange: true, skip: !shouldLoadGaiaObject }
  );

  const {
    data: scanResultData,
    error: scanResultError,
    isLoading: scanResultLoading,
    isError: scanResultIsError,
  } = useGetScanResultQuery(
    { shortId: shortId! },
    { refetchOnMountOrArgChange: true, skip: !shouldLoadScanResult }
  );

  const {
    data: scanJobData,
    error: scanJobError,
    isLoading: scanJobLoading,
    isError: scanJobIsError,
  } = useGetScanjobQuery(
    { shortId: shortId! },
    { refetchOnMountOrArgChange: true, skip: !shouldLoadScanJob }
  );

  const { data: contactsList } = useGetContactsListQuery(
    { teamName: teamName },
    {
      refetchOnFocus: true,
      skip: !teamName || teamName === GaiaConstants.PLACE_HOLDER,
    }
  );

  // Combine all errors and loading states
  const combinedError = gaiaObjectError || scanResultError || scanJobError;
  const combinedLoading =
    gaiaObjectLoading || scanResultLoading || scanJobLoading;
  const combinedIsError =
    gaiaObjectIsError || scanResultIsError || scanJobIsError;

  return {
    gaiaObjectData: shouldLoadGaiaObject ? gaiaObjectData : undefined,
    scanResultData,
    scanJobData,
    contactsList,
    error: combinedError,
    isLoading: combinedLoading,
    isError: combinedIsError,
    shouldLoadGaiaObject,
    gaiaObjectLoading: shouldLoadGaiaObject ? gaiaObjectLoading : undefined,
  };
};
